import React from "react";
import PropTypes from "prop-types";
import { Button, Header, Icon } from "semantic-ui-react";

const HomepageSignpostButton = ({
  backgroundColor,
  icon,
  title,
  description,
  href,
}) => (
  <Button
    className="homepage-signpost-btn"
    fluid
    href={href}
    style={{
      backgroundColor,
      color: "#000",
      borderRadius: "1rem",
      padding: "2em",
      textAlign: "left",
    }}
  >
    <div style={{ display: "flex", alignItems: "flex-start", gap: "1em" }}>
      {icon}
      <div>
        <Header as="h3">{title}</Header>
        <p
          style={{
            fontWeight: "normal",
            fontSize: "1rem",
            color: "#000",
          }}
        >
          {description}
        </p>
      </div>
    </div>
  </Button>
);

HomepageSignpostButton.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  href: PropTypes.string,
};

export default HomepageSignpostButton;
